import { useTranslation } from 'react-i18next';
import ErrorPage from '../components/ErrorPage';

// Any address that matches no page (see the "*" route in App.js).
function NotFound() {
  const { t } = useTranslation();
  return <ErrorPage title={t('notFound.title')} body={t('notFound.body')} />;
}

export default NotFound;
